<template>
  <div
    class="w-full block"
    tabindex="-1"
  >
    <router-link
      id="sideMenuLink"
      :to="path"
      tabindex="-1"
    >
      <button
        class="sidebar-btn"
        :class="isCurrentSel ? 'sidebar-btn--active' : 'sidebar-btn--idle'"
        tabindex="0"
        @click="select(btnText)"
      >
        <!-- Active indicator bar -->
        <div class="sidebar-btn__indicator" :class="isCurrentSel && 'sidebar-btn__indicator--active'" />
        <div class="sidebar-btn__icon-wrap">
          <font-awesome-icon :icon="btnIcon" class="sidebar-btn__icon text-2xl" />
          <div v-if="displayNotifications && mainMenuCollapsed" class="sidebar-btn__notif-dot" />
        </div>
        <p
          class="sidebar-btn__label"
        >
          {{ mainMenuCollapsed && screen.lg ? '' : btnText }}
        </p>
        <span
          v-if="displayNotifications && !mainMenuCollapsed"
          class="sidebar-btn__badge"
          :class="isCurrentSel ? 'sidebar-btn__badge--active' : ''"
        >
          {{ numNotifications }}
        </span>
      </button>
    </router-link>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex"

export default {
  name: "SideMenuButton",
  components: {
  },
  props: {
    section: {
      type: Object,
      required: true
    },
    btnText: {
      type: String,
      required: true
    },
    btnIcon: {
      type: String,
      required: true
    },
    isSinglePage: {
      type: Boolean,
      required: false
    },
  },
  computed: {
    ...mapState(["screen", "orientation"]),
    ...mapGetters(["mainMenuCollapsed", "sidemenuNotifications"]),
    path() {
      return `/${this.btnText.replace(/\s/g, '')}`
    },
    isCurrentSel() {
      return this.$route.path.includes(this.path)
    },
    numNotifications() {
      return this.sidemenuNotifications[this.section.module]?.count
    },
    displayNotifications() {
      return this.numNotifications > 0
    }
  }, 
  methods: {
    ...mapMutations([
      'toggleMobileSubMenu',
      "CLOSE_MOBILEMENU",
      "collapseSectionMenu"
    ]),
    select() {
      this.toggleMobileSubMenu(true)
      this.collapseSectionMenu(false)
      window.scrollTo(0, 0)
      if (this.isSinglePage) {
        this.CLOSE_MOBILEMENU()
      }
    }
  }
}
</script>

<style>
.sidebar-btn {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0.625rem 0.5rem 0.625rem 0;
  color: rgba(255, 255, 255, 0.75);
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.8125rem;
  letter-spacing: 0.03em;
  outline: none;
  transition: all 0.2s ease;
  min-height: 52px;
  line-height: 1.3;
  cursor: pointer;
  background: transparent;
  border: none;
  text-align: left;
}

.sidebar-btn--idle:hover {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.08);
}
.sidebar-btn--idle:focus {
  background: rgba(255, 255, 255, 0.06);
}

.sidebar-btn--active {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.12);
}

/* Left accent indicator */
.sidebar-btn__indicator {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 0;
  background: #ffffff;
  border-radius: 0 2px 2px 0;
  transition: height 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}
.sidebar-btn__indicator--active {
  height: 60%;
}

/* Icon */
.sidebar-btn__icon-wrap {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  flex-shrink: 0;
  margin-left: 1rem;
  margin-right: 0.625rem;
}

.sidebar-btn__icon {
  /* font-size: 1.375rem; */
  transition: transform 0.2s ease;
}
.sidebar-btn:hover .sidebar-btn__icon {
  transform: scale(1.05);
}

.sidebar-btn__notif-dot {
  position: absolute;
  top: 0;
  right: 0.125rem;
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background: #ef4444;
  box-shadow: 0 0 0 2px #3a559e;
  animation: notif-pulse 2s ease-in-out infinite;
}

/* Label */
.sidebar-btn__label {
  text-align: left;
  margin-right: 0.25rem;
  flex: 1;
  min-width: 0;
}

/* Notification badge */
.sidebar-btn__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.25rem;
  height: 1.25rem;
  padding: 0 0.375rem;
  font-size: 0.6875rem;
  font-weight: 700;
  border-radius: 9999px;
  background: #ef4444;
  color: #ffffff;
  margin-left: auto;
  margin-right: 0.75rem;
  line-height: 1;
  animation: badge-enter 0.3s ease-out;
}
.sidebar-btn__badge--active {
  background: #ffffff;
  color: #151e38;
}

@keyframes notif-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

@keyframes badge-enter {
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

@media screen and (min-width: 1024px) {
  .sidebar-btn {
    padding: 0.5rem 0.5rem 0.5rem 0;
    font-size: 0.75rem;
    min-height: 48px;
  }
  .sidebar-btn__icon-wrap {
    margin-left: 0.75rem;
    margin-right: 0.5rem;
  }
  .sidebar-btn__icon {
    font-size: 1.25rem;
  }
}
</style>